import * as tslib_1 from "tslib";
import GlobalTheme from '@atlaskit/theme';
import * as React from 'react';
import Container from './Container';
import Format from './Format';
import { Theme } from '../theme';
var Badge = /** @class */ (function (_super) {
    tslib_1.__extends(Badge, _super);
    function Badge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // TODO This can be removed when we remove support for onValueUpdated.
    Badge.prototype.componentWillUpdate = function (nextProps) {
        var _a = this.props, children = _a.children, onValueUpdated = _a.onValueUpdated, value = _a.value;
        var oldValue = children;
        var newValue = nextProps.children;
        // This allows us to still prefer the value prop to maintain backward
        // compatibility.
        if (value !== null) {
            oldValue = value;
        }
        if (nextProps.value !== null) {
            newValue = nextProps.value;
        }
        if (onValueUpdated && newValue !== oldValue) {
            onValueUpdated({ oldValue: oldValue, newValue: newValue });
        }
    };
    Badge.prototype.render = function () {
        var _a = this.props, theme = _a.theme, appearance = _a.appearance, children = _a.children, max = _a.max, value = _a.value;
        return (React.createElement(Theme.Provider, { value: theme },
            React.createElement(GlobalTheme.Consumer, null, function (_a) {
                var mode = _a.mode;
                return (React.createElement(Theme.Consumer, { appearance: appearance, mode: mode }, function (tokens) { return (React.createElement(Container, tslib_1.__assign({}, tokens), typeof children === 'string' ? (children) : (React.createElement(Format, { max: max }, value || children)))); }));
            })));
    };
    Badge.displayName = 'Ak.Badge';
    Badge.defaultProps = {
        appearance: 'default',
        children: 0,
        max: 99,
        onValueUpdated: function () { },
        value: undefined,
    };
    return Badge;
}(React.Component));
export default Badge;
//# sourceMappingURL=index.js.map